import React from "react";
import { cn } from "@/lib/utils";

export default function AdminKpiGrid({ children, className }) {
  return (
    <div className={cn("grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6", className)}>
      {children}
    </div>
  );
}

export function AdminKpiTile({ label, value, color = "text-white", onClick, testId, active = false }) {
  const inner = (
    <>
      <div className="admin-muted text-xs sm:text-sm font-['Manrope'] mb-1">{label}</div>
      <div className={`text-2xl sm:text-3xl font-['Unbounded'] font-bold ${color}`}>{value}</div>
    </>
  );
  const cls = `admin-glass p-4 sm:p-6 text-left w-full ${active ? "border-blue-400" : ""}`;
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls} data-testid={testId} aria-pressed={active}>
        {inner}
      </button>
    );
  }
  return (
    <div className={cls} data-testid={testId}>
      {inner}
    </div>
  );
}
